module.exports = __webpack_public_path__ + "img/glod-logo-white.ba82e196.png";